export enum LanguagesEnum {
  ENGLISH = "EN",
  SPANISH = "ES",
}

export enum LanguagesCodeEnum {
  ENGLISH = "en",
  SPANISH = "es",
}

export enum LanguagesNameEnum {
  ENGLISH = "English",
  SPANISH = "Español",
}
